import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid, Stack, Button } from "@mui/material";
import ComponentsView from "./components/ComponentsView";
import StructuresView from "./components/StructuresView";
import TemplatesView from "./components/TemplatesView";
import PropTypes from "prop-types";
import { buttonStyles } from "services/utils";

const SetupView = ({ canEdit }) => {
  const { t } = useTranslation();
  const [activeSubTab, setActiveSubTab] = useState(0);

  const buttons = [
    { label: t("admin.payroll.setup.components"), viewIndex: 0 },
    { label: t("admin.payroll.setup.structures"), viewIndex: 1 },
    { label: t("admin.payroll.setup.templates"), viewIndex: 2 },
  ];

  return (
    <Box>
      <Stack pb={2}>
        <Grid container spacing={1} sx={{ justifyContent: { xs: "center", md: "flex-start" } }}>
          {buttons.map(({ label, viewIndex }) => (
            <Grid item xs={12} sm={4} md="auto" key={viewIndex}>
              <Button
                sx={{
                  ...buttonStyles(activeSubTab === viewIndex),
                  width: { xs: "100%", md: "auto" },
                }}
                variant={activeSubTab === viewIndex ? "contained" : "outlined"}
                onClick={() => setActiveSubTab(viewIndex)}
                color="primary"
              >
                {label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Stack>

      <Box>
        {activeSubTab === 0 && <ComponentsView canEdit={canEdit} />}
        {activeSubTab === 1 && <StructuresView canEdit={canEdit} />}
        {activeSubTab === 2 && <TemplatesView canEdit={canEdit} />}
      </Box>
    </Box>
  );
};

SetupView.propTypes = {
  canEdit: PropTypes.bool.isRequired,
};

export default SetupView;
